import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { signOut } from 'aws-amplify/auth';

export const authService = {
    // Check if user is currently authenticated
    async checkAuthStatus() {
        try {
            const currentUser = await getCurrentUser();
            const session = await fetchAuthSession();
            
            if (currentUser && session.tokens) {
                return {
                    isAuthenticated: true,
                    user: {
                        username: currentUser.username,
                        attributes: currentUser.signInDetails?.loginId || currentUser.username
                    }
                };
            }
            return { isAuthenticated: false, user: null };
        } catch (error) {
            console.log('No authenticated user found:', error);
            return { isAuthenticated: false, user: null };
        }
    },

    // Sign out user
    async signOut() {
        try {
            await signOut();
            return true;
        } catch (error) {
            console.error('Error signing out:', error);
            return false;
        }
    },

    // Get current user info
    async getCurrentUserInfo() {
        try {
            const currentUser = await getCurrentUser();
            return currentUser;
        } catch (error) {
            console.error('Error getting current user:', error);
            return null;
        }
    }
};
